/**
 * vee-validate
 * https://logaretm.github.io/vee-validate/guide/rules.html#rules
 */
import { ValidationObserver, ValidationProvider, localize, extend } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import * as rules from 'vee-validate/dist/rules'
import Vue from 'vue'
import moment from 'moment'
import {BigNumber} from "bignumber.js";

// VeeValidateが用意している全てのルールを適用
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
/**
 * 選択したファイルのチェックを行う.
 * ファイル選択中に選択したファイルを更新、または削除した場合のチェック処理
 */
extend('fileChecker', {
  async validate(value) {
    const f = value
    if(f.size === 0 && Math.abs((new Date()).getTime() - f.lastModified) < 1000){
      return false
    }
    const hasError = await f.slice(0, 1).text().then(() => false).catch(() => true)
    if (!hasError) {
      // ファイル送信処理
    } else {
      // エラーメッセージを表示
      return false
    }
    return true
  },
  message: "ファイルの更新か削除が行われました。ファイルを再度選択してください。"
})

/**
 * メール内容に${url}が含まれているかをチェック
 */
extend('mail_template_url', {
  validate(value) {
    if (!value) {
      return false
    }
    return value.includes('${url}')
  },
  message: "メール内容には${url}を含める必要があります"
})

/**
 * 運搬ルートマスタ
 * コード重複チェック
 */
extend('routeCodeExists', {
  params:['counter'],
  async validate(value, { counter }) {
    return counter <= 0
  },
  message: "{_field_}は既に存在します"
})


/**
 * ファイルサイズのチェックを行う.
 * 用意されているvalidationがKBしか対応していなかったため、MBで表現するチェックを用意.
 * @param size_as_mega { Number } MB数を指定
 */
extend('megaFileSizeChecker', {
  params: [ 'size_as_mega' ],
  validate(value, { size_as_mega }) {
    if (value === null) {
      return true
    }
    let standardSize = size_as_mega * 1024000
    if (standardSize < value.size) {
      return false
    }
    return true
  },
  message: "{_field_}は{size_as_mega}Mb以下のファイルを指定してください"
})
extend('comparePeriodDate', {
  params: ['collected_date'],
  validate(value, {collected_date}) {
    // console.log('comparePeriodDate in.')
    // console.log('period_date', value)
    // console.log('collected_date', collected_date)
    if (value === null || collected_date === null) {
      return true
    }
    let period_date = moment(value)
    let comparison_date = moment(collected_date)
    let limit_date = comparison_date.add(3, 'months')
    // console.log('limit_date', limit_date)
    // console.log('period_date', period_date)
    if (limit_date.diff(period_date) < 0){
      return false
    }
    if (value < collected_date){
      return false
    }
    return true
  },
  message: "{_field_}は期間外です。回収日から3ヶ月以内で選択してください。"
})

extend('rangeInDate', {
  params: ['manifest_type', 'min', 'max'],
  validate(value, {manifest_type, min, max}) {
    if (!manifest_type || manifest_type !== 'dxe_form') {
      return true;
    }
    if (value === null) {
      return true
    }
    let period_date = moment(value)
    let comparison_date = moment(min)
    let limit_date = moment(max)
    if (limit_date.diff(period_date) < 0){
      return false
    }
    if (period_date.diff(comparison_date) < 0){
      return false
    }
    return true
  },
  message: "{_field_}は{min}から{max}までの日付を選択してください。"
})

// 回収日の入力チェック
extend('collectedDateCheck', {
  params: ['past_manifest'],
  validate(value, {past_manifest}) {
    // console.log('value：'+value)
    // console.log('past_manifest：'+past_manifest)
    if(past_manifest){
      if(value <= moment().format('YYYY-MM-DD')){
        return true
      }
    }else{
      if(value >= moment().format('YYYY-MM-DD')){
        return true
      }
    }
    return false
  },
  message(field, {past_manifest}){
    if(past_manifest){
      return field + "は本日より過去日を入力してください。"
    }else{
      return field + "は本日以降を入力してください。"
    }
  }
})

// ログインID 半角のみ（半角4~255文字）
extend('login_id', {
  params:[],
  validate(value) {
    let regex = /^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/
    return regex.test(value)
  },
  message: "{_field_}のフォーマットが正しくありません"
})

// パスワード 半角8~12文字 英小文字・大文字・数字をそれぞれ1種類以上
extend('password', {
  params:[],
  validate(value) {
    let regex = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,12}$/
    return regex.test(value)
  },
  message: "{_field_}のフォーマットが正しくありません"
})

extend('zip_code', {
  params:[],
  validate(value) {
    let regex = /^[0-9]{3}[-][0-9]{4}$/
    return regex.test(value)
  },
  message: "{_field_}のフォーマットが正しくありません"
})

extend('quantityWithDecimal', {
  params:['int_digits', 'dec_digits'],
  validate (value, { int_digits, dec_digits }) {
    if (int_digits === undefined)
      return true
    if (dec_digits === undefined)
      return true

    let _int = int_digits - 1
    _int = _int < 0 ? 0 : _int
    let _dsc = dec_digits ? dec_digits : 3
    if (value) {
      // 整数は 5桁であれば4
      // let role = String.raw`^([1-9][0-9]{0,${_int}}|0)(\.[0-9]{1,${_dsc}})?$`
      // console.log(role)
      const regx = new RegExp(String.raw`^([+-]?[1-9][0-9]{0,${_int}}|0)(\.[0-9]{1,${_dsc}})?$`);
      // console.log(value.match(regx))
      value = `${value}`
      return value.match(regx) !== null
    }
    return true
  },
  message: "{_field_}は整数{int_digits}桁,小数{dec_digits}桁までで入力してください"
})

extend('full_width', {
  params:[],
  validate(value) {
    let regex = /^[^\x20-\x7e]*$/
    return regex.test(value)
  },
  message: "{_field_}は全角のみ使用できます"
})


extend('alpha_num_only', {
  params: [],
  validate(value) {
    let regex = /^[0-9a-zA-Z]+$/
    return regex.test(value)
  },
  message: "{_field_}は英数字のみ使用できます"
})

// 連絡番号
extend('contact_num_only', {
  params: [],
  validate(value) {
    let regex = /^[a-zA-Z0-9!#$&()*+\-./:;=?@[\]\\^`{|}~\s]+$/
    return regex.test(value)
  },
  message: "{_field_}は英数字と記号のみ使用できます"
})

// 数字、ハイフンを認める（電話番号用途）
extend('numeric_hyphen_contract_only', {
  params: [],
  validate(value) {
    let regex = /^0\d{1,4}-\d{1,4}-\d{3,4}$/
    // let regex = /^[0-9-()]+$/
    return regex.test(value)
  },
  message: "{_field_}は数字とハイフンのみ使用できます"
})

// 数字、ハイフンを認める（電話番号用途）
extend('numeric_hyphen_only', {
  params: [],
  validate(value) {
    let regex = /^(?!-)[0-9\-()]+(?<!-)$/;
    return regex.test(value);
  },
  message: "{_field_}は数字、ハイフン、()のみ使用できます"
});

// 全角カタカナ
extend('katakana_only', {
  params: [],
  validate(value) {
    let regex = /^[ァ-ンヴー]*$/
    return regex.test(value)
  },
  message: "{_field_}は全角カタカナのみ使用できます"
})

// カスタムバリデーション
extend('disposalContractorMatcher', {
  params: ['transport_route_details'],
  validate(value, { transport_route_details }) {
    let lastTransportRouteDetail = null
    if (transport_route_details.length === undefined) {
      lastTransportRouteDetail = transport_route_details
    } else {
      let active_sections = []
      for (let i = 0; i < transport_route_details.length; i++) {
        if (!transport_route_details[i]._destroy) {
          active_sections.push(transport_route_details[i])
        }
      }
      lastTransportRouteDetail = active_sections[active_sections.length - 1]
    }
    if (lastTransportRouteDetail === null) {
      return true
    }
    return lastTransportRouteDetail.trader_id === value;
  },
  message: 'ルートの最終運搬先と一致していません。'
})

/**
 * 最終区間以外に処分業者が選択されていないかチェック
 */
extend('intermediateSectionChecker', {
  params: ['traders', 'lastRow'],
  validate(value, { traders, lastRow }) {
    if (lastRow) {
      return true
    }
    let trader = traders.find((v) => v.value === value)
    if (trader) {
      return trader.subscriber_type !== 'disposer_type'
    } else {
      return true
    }
  },
  message: '処分業者は最終区間でのみ選択可能です。'
})

extend ("generalDisposerSectionChecker", {
  params: ['traders', 'section'],
  validate (value, { traders, section }) {

    const trader = traders.find((v) => v.value === value)
    if (trader && trader.type === 'GeneralWasteDisposal' && section > 1 ) {
      return false
    } else {
      return true;
    }
  },
  message: "一般廃棄物処分業者の場合、区間２以降は登録出来ません",
})

extend('traderDisposerMatcher', {
  params: ['disposerId', 'lastRow'],
  validate(value, { disposerId, lastRow }) {
    if (!lastRow) {
      return true
    }
    return (disposerId === value)
  },
  message: '処分業者と一致していません。'
})

extend('disposalContractLocationMatcher', {
  params: ['disposerId', 'transport_route_details'],
  validate(value, { disposerId, transport_route_details }){
    let lastTransportRouteDetail = null
    if (transport_route_details.length === undefined) {
      lastTransportRouteDetail = transport_route_details
    } else {
      let active_sections = []
      for (let i = 0; i < transport_route_details.length; i++) {
        if (!transport_route_details[i]._destroy) {
          active_sections.push(transport_route_details[i])
        }
      }
      lastTransportRouteDetail = active_sections[active_sections.length - 1]
    }
    if (lastTransportRouteDetail === null) {
      return true
    }
    return disposerId === lastTransportRouteDetail.trader_id && lastTransportRouteDetail.trader_location_code === value;
  },
  message: 'ルートの最終運搬先 事業場と一致しません。'
})

extend('traderLocationDisposerLocationMatcher', {
  params: ['traderId', 'disposerId', 'disposerLocationCode', 'lastRow'],
  validate(value, { traderId, disposerId, disposerLocationCode, lastRow }){

    if (!lastRow) {
      return true
    }

    return (traderId === disposerId && value === disposerLocationCode)
  },
  message: '処分事業場と一致しません。'
})

extend('duplicateKeys', {
  params: [ 'keys' ],
  validate (value, { keys }) {
    const otherKeys = keys.filter(Boolean)
    return !(otherKeys.includes(value))
  },
  message: '{_field_}は他で利用されています。'
})

// 文字数：カスタム表示ラベルの入力文字数大小チェック
extend('customLabelsCharacterCheck', {
  params: [ 'custom_labels_maximum_characters' ],
  validate(value, { custom_labels_maximum_characters }) {
    if ((value !== null && custom_labels_maximum_characters !== null) &&
        (custom_labels_maximum_characters < value)){
      return false
    }
    return true
  },
  message: '{_field_}は最大入力文字数よりも小さい値を指定してください。'
})

// 回収日：希望時間大小チェック
extend('preferredStartTimeCheck', {
  params: [ 'preferred_end_time' ],
  validate(value, { preferred_end_time }) {
    if ((value !== null && preferred_end_time !== null) &&
        (preferred_end_time < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了時間よりも前を指定してください。'
})

// 加入者番号頭文字チェック
extend('subscriberNumberInitialsCheck', {
  // params: [ 'mode' ],
  params: [ 'mode', 'contract_type' ],
  validate(value, { mode, contract_type }) {
    let regex = ""
    if (contract_type !== "demo_contract") {
      if( mode === "transport" || mode === "admin_transport"){
        regex = /^[2D]/
      } else if(mode === "disposer" || mode === "admin_disposer") {
        regex = /^[3D]/
      }
      return regex.test(value)
    } else {
      return true
    }

  },
  message( field, { mode } ) {
    let word = ( mode === "transport" || mode === "admin_transport") ? "2":"3"
    return field + 'の頭文字は「'+ word +'」または「D」を指定してください。'
  }
})

// テナント：正式契約日の入力チェック
extend('chkFormallyContractDate', {
  params: [ 'systemDate', 'registed_formally_contract_date' ],
  validate(value, { systemDate, registed_formally_contract_date }){
    if (value !== registed_formally_contract_date && value <  systemDate){
      return false
    }
    return true
  },
  message: '{_field_}は本日以降を入力してください。'
})
// テナント：電子契約利用開始日 終了日の大小チェック
extend('ecContactStartDateCheck', {
  params: [ 'ec_contract_end_date' ],
  validate(value, { ec_contract_end_date }) {
    if ((value !== null && ec_contract_end_date !== null) &&
        (ec_contract_end_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了日よりも前を指定してください。'
})
// テナント：IP制限利用開始日 終了日の大小チェック
extend('ipRestrictionsStartDateCheck', {
  params: [ 'ip_restrictions_service_stop_date' ],
  validate(value, { ip_restrictions_service_stop_date }) {
    if ((value !== null && ip_restrictions_service_stop_date !== null) &&
        (ip_restrictions_service_stop_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了日よりも前を指定してください。'
})
// テナント：API利用開始日 終了日の大小チェック
extend('apiStartDateCheck', {
  params: [ 'api_end_date' ],
  validate(value, { api_end_date }) {
    if ((value !== null && api_end_date !== null) &&
        (api_end_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了日よりも前を指定してください。'
})

// テナント：API利用開始日 終了日の大小チェック
extend('freeeStartDateCheck', {
  params: [ 'freee_end_date' ],
  validate(value, { freee_end_date }) {
    if ((value !== null && freee_end_date !== null) &&
      (freee_end_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了日よりも前を指定してください。'
})

// テナント：JWNETデータ取込利用開始日 終了日の大小チェック
extend('jwnetTransferStartDateCheck', {
  params: [ 'jwnet_transfer_end_date' ],
  validate(value, { jwnet_transfer_end_date }) {
    if ((value !== null && jwnet_transfer_end_date !== null) &&
      (jwnet_transfer_end_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了日よりも前を指定してください。'
})
// テナント:他社区間代行起票利用開始日 終了日の大小チェック
extend('proxyEntryStartDateCheck', {
  params: [ 'proxy_entry_end_date' ],
  validate(value, { proxy_entry_end_date }) {
    if ((value !== null && proxy_entry_end_date !== null) &&
      (proxy_entry_end_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は終了日よりも前を指定してください。'
})

/**
 * 廃棄物受領日 処分終了日の大小チェック
 */
extend('disposalReportReceiptDateCheck', {
  params: [ 'disposal_report_end_date' ],
  validate(value, { disposal_report_end_date }) {
    if ((value !== null && disposal_report_end_date !== null) &&
        (disposal_report_end_date < value)){
      return false
    }
    return true
  },
  message: '{_field_}は処分終了日より未来の日付は登録できません'
})

/**
 * パターンリスト
 * リストの必須チェック
 * 空の場合はエラーとする.
 */
extend('pMLength', {
  params: [ 'targetList' ],
  validate(value, { targetList }) {
    const length = targetList.length;
    return length > 0;
  },
  message: "パターンを追加してください。"
});

/**
 * 処分場処理方法登録
 * 処分割合 合計値の検証
 */
extend('pMFull', {
  params: [ 'targetList' ],
  validate(value, { targetList }) {
    if (targetList.length <= 0) {
      return true;
    }
    let totalize = 0;
    targetList.forEach(target => {
      totalize += Number(target.before_disposal_ratio);
    })
    return totalize === 100;
  },
  message: "処分割合の合計が100%になるように設定してください"
});

/**
 * 最終処分終了報告
 * 01工程のみの場合はエラー
 */
extend('pMOnlyFirstLayer', {
  params: [ 'targetList' ],
  validate(value, { targetList }) {
    if (targetList.length <= 0) {
      return true;
    }

    let hasOtherLayer = false;
    targetList.forEach(target => {
      if (target.level > 1) {
        hasOtherLayer = true;
      }
    })
    return hasOtherLayer
  },
  message: "01工程のみの登録はできません。"
})

/**
 * 01工程割合合計
 */
extend('pmFirstBeforeRatioTotal', {
  validate(value, { targetList }) {
    if (targetList.length <= 0) {
      return true;
    }
    let totalize = 0;
    targetList.forEach(target => {
      if (target.level === 1) {
        totalize += Number(target.before_disposal_ratio);
      }
    })
    return 100 === totalize;
  },
  params: [ 'targetList' ],
  message: `01工程の合計は100%になるように設定してください。`
});

extend('requestRatioTotal', {
  validate(value, { targetList }) {
    if (targetList.length <= 0) {
      return true;
    }
    let totalize = 0;
    targetList.forEach(target => {
      totalize += Number(target.request_ratio);
    })
    return 100 === totalize;
  },
  params: [ 'targetList' ],
  message: `依頼割合の合計は100%となるように設定して下さい。`
})

/**
 * 01工程重量合計の範囲
 */
extend('pmFirstBeforeWeightTotalRange', {
  params: ['targetList', 'final_disposal_quantity'],
  validate(value, { targetList, final_disposal_quantity }) {

    if (targetList.length <= 0) {
      return true;
    }
    const baseQuantity = new BigNumber(final_disposal_quantity || 0);

    // 基準値が0以下の場合は判定不可
    if (baseQuantity.isLessThanOrEqualTo(0)) {
      return true;
    }
    // 合計値
    const total = targetList.reduce((sum, item) => {
      if (item.level !== 1) {
        return sum;
      }
      return sum.plus(item.before_disposal_weight || 0);
    }, new BigNumber(0));

    // 90% ～ 110%
    const min = baseQuantity.multipliedBy('0.9');
    const max = baseQuantity.multipliedBy('1.1');
    return (
      total.isGreaterThanOrEqualTo(min) &&
      total.isLessThanOrEqualTo(max)
    );
  },
  message: '処分量の合計が重量の90.0%～110.0%（誤差10%）の範囲内となるように設定してください。'
});

/**
 * 最終処分の設定の存在チェック
 * 終端工程には最終処分チェックが必須、中間工程には設定不可
 *
 * 終端工程の判定：リストはlevelの深さ順（前順走査）で並んでいるため、
 * 「次の工程のlevelが自身以下、または末尾」であれば子工程を持たない終端工程とみなせる。
 */
extend('pMExceptFinalDisposal', {
  params: [ 'targetList' ],
  validate(value, { targetList }) {
    if (targetList.length <= 0) {
      return true;
    }

    return targetList.every((item, index) => {
      // 次工程のlevelが自身以下、または末尾であれば終端工程
      const isLeaf = index === targetList.length - 1 || targetList[index + 1].level <= item.level;
      // 終端工程は最終処分必須、中間工程は最終処分不可
      return isLeaf ? item.final_disposal : !item.final_disposal;
    });
  },
  message: "各工程の終わりは必ず最終処分にチェックがされている必要があります。"
});

/**
 *
 */
extend('pMIsIncludeItem', {
  params: [ 'targetList', 'targetItemIds' ],
  validate(value, { targetList, targetItemIds }) {

    // 工程なしはここではチェックしない
    if (targetList.length <= 0) {
      return true;
    }

    // 取扱品目なしであればチェックしない
    if (targetItemIds.length <= 0) {
      return true;
    }
    let success = true;
    targetList.forEach(target => {
      if (target.level === 1 && target.item_ids.length > 0 ) {
        const setB = new Set(targetItemIds);
        if (!target.item_ids.some(item => setB.has(item))) {
          success = false;
        }
      }
    })
    return success;
  },
  message: "01工程の処分前廃棄物種類と取扱品目が一致しません。取扱品目または処分場処理方法を再度選択してください。"
})




// トピック: 表示開始日 終了日の大小チェック
extend('topicStartDateCheck', {
  params: ['end_date'],
  validate(value, { end_date }) {
    if (!value || !end_date) return true;
    return moment(value).isSameOrBefore(moment(end_date));
  },
  message: '{_field_}は表示終了日以前の日付を指定してください'
});

// トピック: URL形式チェック
extend('topicUrlCheck', {
  validate(value) {
    if (!value || value.trim() === '') {
      return true;
    }

    let regex = /^https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+/;
    return regex.test(value);
  },
  message: '{_field_}は正しいURL形式で入力してください'
});

/**
 * ２次マニフェスト起票 自己処分判定
 * == 前提条件
 * ・対象が２次マニフェストであること
 * ・マスタからの登録であること
 * ・排出事業者(自社処分業者)が選択されていること
 * ・処分業者(ルート選択)が選択されていること
 * == 判定処理
 * ・排出事業者(自社処分業者)の加入者番号と、処分業者(ルート選択)の加入者番号が一致する場合はエラーとする
 */
extend('secondManifestSameDisposalCheck',{
  params: [ 'level' ,'form_type', 'supplier_subscriber_number',  'disposer_subscriber_number' ],
  validate(value, { level, form_type, supplier_subscriber_number, disposer_subscriber_number }) {
    // console.table({'level': level, 'form_type': form_type, 'supplier_subscriber_number': supplier_subscriber_number, 'disposer_subscriber_number': disposer_subscriber_number})

    if (level !== 'second_manifest') {
      return true
    }

    if (form_type !== 'master_mode') {
      return true
    }

    if (!supplier_subscriber_number) {
      return true
    }

    if (!disposer_subscriber_number) {
      return true
    }
    return supplier_subscriber_number !== disposer_subscriber_number
  },
  message: '自己処分の登録はできません'
})

/**
 * 排出事業者加入者番号 妥当性チェック
 * @description
 * JWNETマニフェスト取込機能より排出事業者に処分業者の加入者番号が登録できるように変更となる。
 * ただし、EDIでの登録は行えず、紙 or Webでの登録は可能
 * このvalidationではその制御を行う.
 */
extend("emissionSubscriberNumber", {
  params: [ "manifest_type" ],
  validate(value, { manifest_type }) {
    let emissionIdentifier = /^(D1|1)$/;
    // 加入者番号が空の場合はスキップ
    if (!value) {
      return true;
    }

    if (manifest_type !== "dxe_form") {
      return true;
    }

    return emissionIdentifier.test(value);
  },
  message: '不正な加入者番号です。'
});

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
localize('ja', ja)
